export enum EditorViewMode {
  SITE = 'site',
  PREVIEW = 'preview',
  EDITOR = 'editor',
}

export const EDITOR_VIEW_MODE = {
  SITE: EditorViewMode.SITE,
  PREVIEW: EditorViewMode.PREVIEW,
  EDITOR: EditorViewMode.EDITOR,
};
